import React, { useMemo } from 'react';

import { useHomeownerTranslate } from '../../hooks';
import type { DesignerMaterialProduct } from '../../types';

import type { MaterialPaletteCardProps } from './MaterialPaletteCard';
import { MaterialPaletteCard } from './MaterialPaletteCard';
import type {
  SelectPaletteSheetLoadingProps,
  SelectPaletteSheetProps,
} from './SelectPaletteSheet';
import { SelectPaletteSheet } from './SelectPaletteSheet';

export interface MaterialPaletteSheetProps
  extends Omit<SelectPaletteSheetProps, 'children'>,
    SelectPaletteSheetLoadingProps {
  materials: DesignerMaterialProduct[];
  region: MaterialPaletteCardProps['region'];
}

export const MaterialPaletteSheet = ({
  isLoading = false,
  materials,
  placeholderCount = 10,
  ...props
}: MaterialPaletteSheetProps) => {
  const t = useHomeownerTranslate();
  const loadingText = t('customize.skeletonLoading');

  const placeholders = useMemo(
    () => Array.from({ length: placeholderCount }, (_, i) => i + 1),
    [placeholderCount],
  );

  const names = useMemo(
    () => [
      ...materials.reduce(
        (acc, { palettes }) => new Set([...acc, ...palettes]),
        new Set<string>(),
      ),
    ],
    [materials],
  );

  const mergedProps = { ...props, isLoading };

  return (
    <SelectPaletteSheet {...mergedProps}>
      {(isLoading ? placeholders : names).map(name => (
        <MaterialPaletteCard
          isLoading={typeof name === 'number'}
          key={name}
          name={typeof name === 'string' ? name : loadingText}
          region={props.region}
        />
      ))}
    </SelectPaletteSheet>
  );
};
